/////////////////////////////////////////////// ONBOARDING ///////////////////////////////////////////////
export const IS_LOAGIN = 'IS_LOAGIN';
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const TOGGLE_PASSWORD = "TOGGLE_PASSWORD";
export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";
export const FORGET_PASSWORD_REQUEST = "FORGET_PASSWORD_REQUEST";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const ONBOARDING_NAVIGATION_REQUEST = "ONBOARDING_NAVIGATION_REQUEST";
export const ONBOARDING_NAVIGATION_RESET = "ONBOARDING_NAVIGATION_RESET";
export const UPDATE_FORGET_PASSWORD_OTP = "UPDATE_FORGET_PASSWORD_OTP";
export const VERIFY_OTP = "VERIFY_OTP";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const TOGGLE_CONFIRM_PASSWORD = "TOGGLE_CONFIRM_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const ME_CALL_REQUEST = "ME_CALL_REQUEST";
export const ME_CALL_SUCCESS = "ME_CALL_SUCCESS";
export const PERMISSIONS_CALL_REQUEST = "PERMISSIONS_CALL_REQUEST";
export const PERMISSIONS_CALL_REQUEST_SUCCESS = "PERMISSIONS_CALL_REQUEST_SUCCESS";
/////////////////////////////////////////////// PROJECTS ///////////////////////////////////////////////
export const PROJECTS_REQUEST = "PROJECTS_REQUEST";
export const PROJECTS_SUCCESS = "PROJECTS_SUCCESS";
export const PROJECTS_FAILURE = "PROJECTS_FAILURE";
export const NAVIGATION_REQUEST = "NAVIGATION_REQUEST";
export const NAVIGATION_RESET = "NAVIGATION_RESET";
export const PROJECT_EDIT_PAGE_REQUEST = "PROJECT_EDIT_PAGE_REQUEST";
export const PROJECT_EDIT_PAGE_SUCCESS = "PROJECT_EDIT_PAGE_SUCCESS";
export const PROJECT_DELETE_CONFIRM = "PROJECT_DELETE_CONFIRM";
export const PROJECT_DELETE_CONFIRM_DECLINE = "PROJECT_DELETE_CONFIRM_DECLINE";
export const PROJECT_DELETE_REQUEST = "PROJECT_DELETE_REQUEST";
export const PROJECT_DELETE_FAILURE = "PROJECT_DELETE_FAILURE";
export const PROJECT_DELETE_SUCCESS = "PROJECT_DELETE_SUCCESS";
export const PROJECT_CREATE_REQUEST = "PROJECT_CREATE_REQUEST";
export const PROJECT_CREATE_SUCCESS = "PROJECT_CREATE_SUCCESS";
/////////////////////////////////////////////// PROJECT UNITS ///////////////////////////////////////////////
export const PROJECT_UNITS_REQUEST = "PROJECT_UNITS_REQUEST";
export const PROJECT_UNITS_SUCCESS = "PROJECT_UNITS_SUCCESS";
export const PROJECT_UNITS_FAILURE = "PROJECT_UNITS_FAILURE";
export const PROJECT_UNIT_EDIT_PAGE_REQUEST = "PROJECT_UNIT_EDIT_PAGE_REQUEST";
export const PROJECT_UNIT_EDIT_PAGE_SUCCESS = "PROJECT_UNIT_EDIT_PAGE_SUCCESS";
export const PROJECT_UNIT_DELETE_CONFIRM = "PROJECT_UNIT_DELETE_CONFIRM";
export const PROJECT_UNIT_DELETE_CONFIRM_DECLINE = "PROJECT_UNIT_DELETE_CONFIRM_DECLINE";
export const PROJECT_UNIT_DELETE_REQUEST = "PROJECT_UNIT_DELETE_REQUEST";
export const PROJECT_UNIT_DELETE_FAILURE = "PROJECT_UNIT_DELETE_FAILURE";
export const PROJECT_UNIT_DELETE_SUCCESS = "PROJECT_UNIT_DELETE_SUCCESS";
export const PROJECT_UNIT_CREATE_REQUEST = "PROJECT_UNIT_CREATE_REQUEST";
export const PROJECT_UNIT_CREATE_SUCCESS = "PROJECT_UNIT_CREATE_SUCCESS";
/////////////////////////////////////////////// BOOKINGS ///////////////////////////////////////////////
export const BOOKING_REQUEST = "BOOKING_REQUEST";
export const BOOKING_SUCCESS = "BOOKING_SUCCESS";
export const BOOKING_FAILURE = "BOOKING_FAILURE";
export const BOOKING_EDIT_PAGE_REQUEST = "BOOKING_EDIT_PAGE_REQUEST";
export const BOOKING_EDIT_PAGE_SUCCESS = "BOOKING_EDIT_PAGE_SUCCESS";
export const BOOKING_DELETE_CONFIRM = "BOOKING_DELETE_CONFIRM";
export const BOOKING_DELETE_CONFIRM_DECLINE = "BOOKING_DELETE_CONFIRM_DECLINE";
export const BOOKING_DELETE_REQUEST = "BOOKING_DELETE_REQUEST";
export const BOOKING_DELETE_FAILURE = "BOOKING_DELETE_FAILURE";
export const BOOKING_DELETE_SUCCESS = "BOOKING_DELETE_SUCCESS";
export const BOOKING_CREATE_REQUEST = "BOOKING_CREATE_REQUEST";
export const BOOKING_CREATE_OR_UPDATE_PAGE_REQUEST = "BOOKING_CREATE_OR_UPDATE_PAGE_REQUEST";
export const BOOKING_PROJECT_OPTIONS_REQUEST = "BOOKING_PROJECT_OPTIONS_REQUEST";
export const BOOKING_PROJECT_OPTIONS_SUCCESS = "BOOKING_PROJECT_OPTIONS_SUCCESS";
export const BOOKING_PROJECT_OPTIONS_FAILURE = "BOOKING_PROJECT_OPTIONS_FAILURE";
export const BOOKING_PROJECT_UNIT_OPTIONS_REQUEST = "BOOKING_PROJECT_UNIT_OPTIONS_REQUEST";
export const BOOKING_PROJECT_UNIT_OPTIONS_SUCCESS = "BOOKING_PROJECT_UNIT_OPTIONS_SUCCESS";
export const BOOKING_PROJECT_UNIT_OPTIONS_FAILURE = "BOOKING_PROJECT_UNIT_OPTIONS_FAILURE";
export const SET_PROJECT_UNIT_OPTIONS = "SET_PROJECT_UNIT_OPTIONS";